import { useState } from "react";

import { generateAutomationName } from "app/pages/activation/helpers/generateAutomationName";
import type { ActionableInsight } from "app/pages/activation/types/api";

import { InsightFeedbackThumbsDownButton } from "./InsightFeedbackThumbsDownButton";
import { InsightFeedbackThumbsUpButton } from "./InsightFeedbackThumbsUpButton";

type InsightFeedbackThumbsGroupProps = {
    insightIndex: number;
    insight: ActionableInsight;
};

export const InsightFeedbackThumbsGroup = ({ insightIndex, insight }: InsightFeedbackThumbsGroupProps) => {
    const [likeActive, setLikeActive] = useState(false);
    const [dislikeActive, setDislikeActive] = useState(false);

    const onClearLike = () => setLikeActive(false);
    const onClearDislike = () => setDislikeActive(false);

    return (
        <>
            <InsightFeedbackThumbsUpButton
                isActive={likeActive}
                insight={insight}
                onActiveChange={setLikeActive}
                onClearDislike={onClearDislike}
                dataAutomation={generateAutomationName("home", [
                    "insights",
                    "row",
                    String(insightIndex),
                    "feedback",
                    "up",
                ])}
            />

            <InsightFeedbackThumbsDownButton
                insightIndex={insightIndex}
                insight={insight}
                isActive={dislikeActive}
                onActiveChange={setDislikeActive}
                onClearLike={onClearLike}
                dataAutomation={generateAutomationName("home", [
                    "insights",
                    "row",
                    String(insightIndex),
                    "feedback",
                    "down",
                ])}
            />
        </>
    );
};
